<template>
  <div class="telemetry-rpm-parts">
    <span class="telemetry-rpm-parts__data">{{ Math.floor(viewValue) }}</span>
    <span class="telemetry-rpm-parts__label"><span>rpm</span></span>
  </div>
</template>

<script lang="ts">
import { defineComponent, toRefs } from '@vue/composition-api'
import useTelemetrySectionUtil from '@/components/RaceVideoPage/RaceVideoDataViewPane/hook/useTelemetrySectionUtil'

/**
 * レース動画再生画面 テレメトリー エンジン回転数 数値パーツのコンポーネント
 */
export default defineComponent({
  name: 'TelemetryRpmParts',
  components: {},
  props: {
    /**
     * バリュー値
     */
    value: {
      type: Number,
      required: true,
    },
    /**
     * 表示fpsと受信データ間隔の差分ms
     */
    diffMs: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const { setupIntermediateValue } = useTelemetrySectionUtil()
    const { value } = toRefs(props)
    const viewValue = setupIntermediateValue(value, props.diffMs)
    return {
      viewValue,
    }
  },
  methods: {},
})
</script>

<style lang="scss" scoped>
.telemetry-rpm-parts {
  position: absolute;
  left: calc(#{min(4.2667vw, 1.333em)} + 1.6667em);
  top: calc(#{min(4.2667vw, 1.333em)} + 11.5em);
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-start;
  justify-content: flex-end;
  width: 15.85em;
  text-align: center;
  color: $lime-green;
  line-height: 1;

  &__label {
    font-size: 0.91667em;
    letter-spacing: 0.04em;
    margin-left: 0.3636em;
    opacity: 0.5;
    transform: translateY(12%);

    span {
      font-size: max(1em, 8px);
    }
  }

  &__data {
    font-size: 1.5em;
    letter-spacing: 0.04em;
  }
}
</style>

<style lang="scss">
.race-telemetry-section {
  &--landscape-primary,
  &--landscape-secondary {
    .telemetry-rpm-parts {
      top: calc(#{min(4.2667vw, 1.333em)} + 11em);

      &__label {
        font-size: 1.1em;

        span {
          font-size: 1em;
        }
      }

      &__data {
        font-size: 1.73em;
      }
    }
  }
}
</style>
